import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CONST_AWS_API } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { API as AWS_API } from 'aws-amplify';

@Component({
  selector: 'app-claim-ticket-verification',
  templateUrl: './claim-ticket-verification.component.html',
  styleUrls: ['./claim-ticket-verification.component.scss']
})
export class ClaimTicketVerificationComponent implements OnInit {

  codeOTP = "";
  ticket_key = "";
  constructor(private toastr: ToastrService,@Inject(MAT_DIALOG_DATA) private _data: any,
  private ngxLoader: NgxUiLoaderService,
  private matDialogRef: MatDialogRef<ClaimTicketVerificationComponent>) {
    this.ticket_key = _data.ticket_key;
  }

  ngOnInit() {
  }


  verifyTicketOTP() {
    if (!this.codeOTP) {
      this.toastr.error("Please enter otp.")
      return;
    }

    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        ticket_key: this.ticket_key,
        otp: this.codeOTP
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.VERIFY_TICKET_OTP, data).then(response => {
      this.ngxLoader.stop();
      if (response.data.status == 0) {
        this.matDialogRef.close({verified_otp :this.codeOTP, close : "yes" });
      } else {
        this.toastr.error(response.data.message);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

}
